import styled from 'styled-components';
import { ReactComponent as RawMenuSVG } from '../../../../assets/icons/icon_menu.svg';

export const IconMenu = styled(RawMenuSVG)``;
